import React, { useEffect } from 'react';
import { connect } from "react-redux";
import DlUnit from '../../models/DlUnit';
import './DlUnitEdit.scss';
import { saveUnit } from "./../../actions";


const mapStateToProps = (state) => ({
  dlUnitId: state.dlUnit.dlUnitId, 
  dlUnit: state.dlUnit.dlUnit
});

const mapDispatchToProps = (dispatch) => ({
  saveUnit: (payload) => dispatch(saveUnit(payload))
});

const DlUnitEditForm = ({ dlUnit, dlUnitId, editType, saveUnit }) => {
    let fRefN = [];

    useEffect(function() {
        ['slug', 'uType', 'num'].forEach(
            (nam) => fRefN[nam].current.value = dlUnit[nam]
        );        
        for (const fNam in fRefN) {
            if (fRefN.hasOwnProperty(fNam) && DlUnit.fValNams.hasOwnProperty(fNam) && fRefN[fNam].current!==null) {
                const fVal = ( dlUnit.hasOwnProperty('fVals') && dlUnit.fVals.hasOwnProperty(fNam) ? dlUnit.fVals[fNam] : '' );
                fRefN[fNam].current.value = fVal;                  
            }
        }
    }, [dlUnit]);

    const saveItem = () => {
        let item = new DlUnit();
        ['slug', 'uType', 'num'].forEach(
            (nam) => item[nam] = fRefN[nam].current.value
        );        
        item.fold = dlUnit.fold;
        item.scans = dlUnit.scans;
        for (const fNam in fRefN) {
            if (fRefN.hasOwnProperty(fNam) && DlUnit.fValNams.hasOwnProperty(fNam) && fRefN[fNam].current!==null && fRefN[fNam].current.value!=='') {
                item.fVals[fNam] = fRefN[fNam].current.value;                  
            }
        }
        saveUnit({ itemId: dlUnitId, item });
    }

    const fVPGet = (fNam, fVal, fLabel, fValDefault) => {
        fValDefault = (typeof fValDefault !== 'undefined' ? fValDefault : '');
        fLabel = (typeof fLabel !== 'undefined' ? fLabel : fNam);
        fVal = (typeof fVal !== 'undefined' ? fVal : '');
        fRefN[fNam] = React.createRef();
  
        let fVP = (<tr key={fNam}>
          <td><label htmlFor={fNam}>{fLabel}:</label></td>
          <td><input type="text" name={fNam} size="100" ref={fRefN[fNam]} /></td>
        </tr>);
  
        return fVP;
  
    };
  
    let fVP = [];
    let fieldP;
    let fVal;
    for (const [fNam, fNamPar] of Object.entries(DlUnit.fValNams)) {
        let fLabel = fNam + '';
        if ( editType=='full' || (editType=='hm' && fNamPar.hm) ) {
            fVal = '';
            fLabel = fLabel.replace('_', ' ');
            if (editType=='hm') {
                const hmTitle = DlUnit.hmTitleGet(fNam);
                if (hmTitle!='') {
                    fLabel += ' (' + hmTitle + ')';            
                }            
            }
            fieldP = fVPGet(fNam, fVal, fLabel);
            fVP.push(fieldP);                  
        }
    }

    const fVPSlug = fVPGet('slug', '', 'slug');
    // const fVPUType = fVPGet('uType', '', 'tip');
    const fVPNum = fVPGet('num', '', 'broj');
    const fVPFold = fVPGet('fold', '', 'folder');
    fRefN['uType'] = React.createRef();
    const fVPUType = <tr key="uType">
                        <td><label htmlFor="uType">tip:</label></td>
                        <td>
                            <select name="uType" ref={fRefN['uType']} style={{ marginTop: '0.5em', marginBottom: '0.5em', width: '100%' }} >
                                <option value="KD">KD - katalog</option>
                                <option value="P">P - periodika</option>
                                <option value="D">D - knjige</option>
                                <option value="S">S - serijske</option>
                                <option value="HM">HM - hemeroteka - gradja</option>
                                <option value="HM2">HM2 - hemeroteka</option>
                            </select>
                        </td>
                    </tr>;

    let f1 = (
        <div>
            {/* <span>editType: { editType }</span> */}
            <table width="600" border="0">
                <tbody>
                    {fVPSlug}
                    {fVPUType}
                    {fVPNum}
                    {/* {fVPFold} */}
                    {fVP}
                </tbody>
            </table>
        </div>
    );

    const pdfUpAfter = (res, addOb) => {
        console.log('fUpAfter');
        console.log('res');
        console.log(res);
        console.log('addOb');
        console.log(addOb);      
    };
    const pdfUpOpt = {
        upOnSel: true
    };

    return (
        <div>
            <div className="a-save-p">
                <button onClick={()=>saveItem()}>OK</button>
            </div>
            { f1 }
            <div className="a-save-p">
                <button onClick={()=>saveItem()}>OK</button>
            </div>
        </div>
    );

}

export default connect(mapStateToProps, mapDispatchToProps)(DlUnitEditForm);
